import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

const API_BASE = 'https://api.laviopaperie.com';

// Helper to join base URL and path without double slashes
function joinUrl(base, path) {
  if (!base.endsWith('/') && !path.startsWith('/')) return base + '/' + path;
  if (base.endsWith('/') && path.startsWith('/')) return base + path.slice(1);
  return base + path;
}

const FinalFrame = () => {
  const [workspace, setWorkspace] = useState(null);
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const wrapperRef = useRef(null);
  const [scale, setScale] = useState(1);
  const location = useLocation();

  const selectedPhotos = (location.state && location.state.selectedPhotos) || [];
  const selectedFrameId = Number(localStorage.getItem('selectedFrameId')) || null;

  useEffect(() => {
    const load = async () => {
      if (!selectedFrameId) {
        setError('Frame belum dipilih');
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        const res = await fetch(`${API_BASE}/api/workspaces/${selectedFrameId}`);
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || 'Gagal memuat frame');
        setWorkspace(data.workspace);
        setItems(data.items || []);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [selectedFrameId]);

  const shapeItems = useMemo(() => items.filter(it => it.item_type === 'shape'), [items]);
  const allItems = useMemo(() => items.slice(), [items]);

  // Measure and scale inner canvas to fit wrapper while preserving original canvas aspect
  useEffect(() => {
    const onResize = () => {
      if (!wrapperRef.current || !workspace) return;
      const w = wrapperRef.current.clientWidth || 1;
      const h = wrapperRef.current.clientHeight || 1;
      const cw = Math.max(1, workspace.canvas_width || 1);
      const ch = Math.max(1, workspace.canvas_height || 1);
      const s = Math.min(w / cw, h / ch);
      setScale(s);
    };
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [workspace]);

  if (loading) return <div className="camera-results"><p>Memuat frame...</p></div>;
  if (error) return <div className="camera-results"><p style={{ color:'#dc3545' }}>{error}</p></div>;
  if (!workspace) return null;

  // Render without white workspace: use transparent container sized like canvas, center background
  return (
    <div style={{ padding: 16 }}>
      <h2>Final Frame: {workspace.name}</h2>
      <div ref={wrapperRef} style={{ position:'relative', width:'100%', height:'70vh', background:'transparent', border:'1px solid #e9ecef', borderRadius:12, overflow:'hidden' }}>
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: (workspace.canvas_width || 1000),
            height: (workspace.canvas_height || 700),
            transform: `scale(${scale})`,
            transformOrigin: 'top left',
          }}
        >
          {workspace.background_path && (
            <img src={joinUrl(API_BASE, workspace.background_path)} alt="bg" style={{ position:'absolute', top:0, left:'50%', transform:'translateX(-50%)', height:'100%', width:'auto', objectFit:'contain', pointerEvents:'none', userSelect:'none' }} />
          )}
          {allItems.map((it) => {
            const baseStyle = {
              position:'absolute',
              left: it.x,
              top: it.y,
              width: it.width,
              height: it.height,
              transform: `rotate(${it.rotation_deg || 0}deg)`,
              transformOrigin: 'center center',
              overflow:'hidden',
              borderRadius: it.item_type === 'asset' ? 0 : (it.border_radius || 0),
              zIndex: it.layer === 'back' ? 1 : 3,
            };
            if (it.item_type === 'asset') {
              return (
                <div key={`asset-${it.id}`} style={baseStyle}>
                  {it.src_path ? (
                    <img src={joinUrl(API_BASE, it.src_path)} alt={`asset-${it.id}`} style={{ width:'100%', height:'100%', objectFit:'contain' }} />
                  ) : null}
                </div>
              );
            }
            // shape
            const shapeIndex = shapeItems.findIndex(s => s.id === it.id);
            const assignedPhoto = shapeIndex >= 0 && selectedPhotos[shapeIndex] ? joinUrl(API_BASE, `/uploads/${selectedPhotos[shapeIndex]}`) : null;
            return (
              <div key={`shape-${it.id}`} style={baseStyle}>
                {assignedPhoto ? (
                  <img src={assignedPhoto} alt={`ph-${shapeIndex+1}`} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                ) : (
                  <div style={{ width:'100%', height:'100%', background:'rgba(0,0,0,0.06)', display:'flex', alignItems:'center', justifyContent:'center', color:'#6c757d' }}>No Photo</div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FinalFrame;


